import { MutationFunction } from '@tanstack/react-query';

import api from '../../../api';

export const postIncentiveCampaignOptin: MutationFunction<string, any> = async (
  campaignId: string
) => {
  return api.post(`/loyalty/incentive-campaign/${campaignId}`).then((resp) => resp.data);
};
